'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { Suspense } from 'react'

import { Cart } from '@/components/Cart'
import { OpenCartButton } from '@/components/Cart/OpenCart'
import { zoneOf } from '@/utilities/zone'
import type { Header } from '@/payload-types'

/**
 * Шапка «Тиража» — не панель с логотипом, а колонтитул и оглавление.
 *
 * Сверху узкая чёрная полоса с выходными данными, под ней строка-оглавление:
 * пункты пронумерованы, между ними точки-лидеры, как в содержании книги.
 * На узком экране оглавление прокручивается вбок — ничего не прячется.
 */
export function RisoHeaderClient({ header }: { header: Header }) {
  const pathname = usePathname()
  const zone = zoneOf(pathname)
  const menu = (zone === 'shop' ? header.shopNav : header.clubNav) || []
  const year = new Date().getFullYear()

  return (
    <header className="riso-head">
      <div className="riso-head__bar">
        <Link href={zone === 'shop' ? '/shop' : '/'}>
          UtroClub<b>✱</b>
          {zone === 'shop' ? 'Мерч' : 'Клуб'}
        </Link>
        <span className="riso-head__mid">Пляжный волейбол · Москва · Тренировки, турниры, кэмпы, мероприятия</span>
        <span>Выпуск {year}</span>
      </div>

      <nav aria-label="Разделы" className="riso-head__toc">
        {menu.map((item, i) => {
          const url = item.link.url || '/'
          const active = url !== '/' ? pathname.startsWith(url) : pathname === '/'

          return (
            <React.Fragment key={item.id ?? i}>
              <Link className="riso-toc__item" data-active={active} href={url}>
                <em>{String(i + 1).padStart(2, '0')}</em>
                {item.link.label}
              </Link>
              <span aria-hidden className="riso-toc__dots" />
            </React.Fragment>
          )
        })}

        <span className="riso-toc__tail">
          <Link className="riso-toc__item" href={zone === 'club' ? '/shop' : '/'}>
            {zone === 'club' ? 'Мерч →' : '← Клуб'}
          </Link>
          <Suspense fallback={<OpenCartButton quiet={zone === 'club'} />}>
            <Cart quiet={zone === 'club'} />
          </Suspense>
        </span>
      </nav>
    </header>
  )
}
